import { render, staticRenderFns } from "./awardRecord.vue?vue&type=template&id=32391d16&scoped=true"
import script from "./awardRecord.vue?vue&type=script&lang=js"
export * from "./awardRecord.vue?vue&type=script&lang=js"
import style0 from "./awardRecord.vue?vue&type=style&index=0&id=32391d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32391d16",
  null
  
)

export default component.exports